<p>customer-personalized-email-notification works!</p>
